import { WorkflowRequests } from "./workflow-requests";

export function AllWorkflowRequests() {
  return <WorkflowRequests requestType="all" />;
}
